export default {
  en: {
    footerDescription: 'FUTONDA is a leading manufacturer of agricultural machinery, specializing in tractors and farming equipment. With over 20 years of experience, we provide innovative solutions for modern agriculture.',
    footerShop: 'Shop',
    footerAllProducts: 'All Products',
    footerNewArrivals: 'New Arrivals',
    footerBestSellers: 'Best Sellers',
    footerSale: 'Sale',
    footerCompany: 'Company',
    footerAboutUs: 'About Us',
    footerContact: 'Contact',
    footerCareers: 'Careers',
    footerBlog: 'News',
    footerHelp: 'Help',
    footerFaq: 'FAQ',
    footerShipping: 'Shipping',
    footerReturns: 'Returns',
    footerPrivacy: 'Privacy',
    footerContactUs: 'Contact Us',
    footerAddress: 'Fangcheng Sub-district, Fangzi District, High-tech Zone,Weifang City, Shandong Province，P.R.China',
    footerPhone: '+86 123 4567 8901',
    copyright: '© 2024 FUTONDA. All rights reserved.',
    inquiry: 'Inquiry',
    inquiryForm: {
      name: 'Name',
      tel: 'Phone',
      email: 'Email',
      message: 'Message',
      sendMessage: 'Send Message'
    }
  },
  zh: {
    footerDescription: '福田达是农业机械制造领域的领军企业，专注于拖拉机和农业设备的研发生产。凭借20多年的行业经验，我们为现代农业提供创新解决方案。',
    footerShop: '商城',
    footerAllProducts: '全部产品',
    footerNewArrivals: '新品上市',
    footerBestSellers: '热销产品',
    footerSale: '特惠专区',
    footerCompany: '公司',
    footerAboutUs: '关于我们',
    footerContact: '联系我们',
    footerCareers: '招贤纳士',
    footerBlog: '新闻动态',
    footerHelp: '帮助',
    footerFaq: '常见问题',
    footerShipping: '物流配送',
    footerReturns: '退换政策',
    footerPrivacy: '隐私政策',
    footerContactUs: '联系我们',
    footerAddress: '中国山东省潍坊市工业园区123号',
    footerPhone: '+86 123 4567 8901',
    copyright: '© 2024 福田达。保留所有权利。',
    inquiry: '询盘',
    inquiryForm: {
      name: '姓名',
      tel: '电话',
      email: '邮箱',
      message: '留言',
      sendMessage: '发送消息'
    }
  }
}; 